import {
  Flex,
  Title,
  Text,
  Chip,
  Button,
  Affix,
  Paper,
  Image,
} from "@mantine/core";

import { useState } from "react";
import { DateInput } from "@mantine/dates";
import { FormattedMessage, useIntl } from "react-intl";
import { usePOAStepsStore } from "../../../hooks/ui/poaStepsDataStore";
import { useUpdateCustomerPOAData } from "../../../hooks/ui/customerPOADataStore";
import FullmaktskollenImage from "/fullmaktskollen-logo.png";

export default function POADuration() {
  const [durationSelection, setDurationSelection] = useState<
    string | undefined
  >("ongoing");
  const [toDate, setToDate] = useState<Date | null>(null);
  const intl = useIntl();
  const { nextStep, prevStep } = usePOAStepsStore();
  const { updateValidFrom, updateValidTo } = useUpdateCustomerPOAData();

  const canProceed =
    !durationSelection || (!toDate && durationSelection === "set-date");

  const handleNext = () => {
    if (durationSelection === "ongoing") {
      updateValidFrom(new Date().toISOString());
      updateValidTo(null);
      nextStep();
    }
    if (durationSelection === "set-date") {
      updateValidFrom(new Date().toISOString());
      updateValidTo(toDate ? toDate.toISOString() : null);
      nextStep();
    }
  };

  return (
    <Flex justify="center" align="center" px={"xl"}>
      <Flex direction="column" maw={672} w={"100%"}>
        <Title
          order={2}
          mb="1rem"
          ff={"var(--wallet-font-family-subjecttivity)"}
        >
          <FormattedMessage
            id="poaDuration.title"
            defaultMessage="How long can we advice you about your pension?"
          />
        </Title>
        <Text mb={"1rem"}>
          <FormattedMessage
            id="poaDuration.paragraph"
            defaultMessage="This power of attorney lets us take a look at your pension and give continuous recommendations on how you can improve your savings. Please choose how long you want us to have access. We suggest giving us access indefinitely."
          />
        </Text>
        <Chip.Group
          multiple={false}
          value={durationSelection}
          onChange={setDurationSelection}
        >
          <Chip variant="buttonChip" mb={"1rem"} value="ongoing">
            <FormattedMessage
              id="poaDuration.option.continously"
              defaultMessage="Continously"
            />
          </Chip>
          <Chip variant="buttonChip" mb={"1rem"} value="set-date">
            <FormattedMessage
              id="poaDuration.option.setDate"
              defaultMessage="Until a set date"
            />
          </Chip>
        </Chip.Group>
        {durationSelection === "set-date" && (
          <DateInput
            value={toDate}
            onChange={setToDate}
            placeholder={intl.formatMessage({
              id: "poaDuration.option.setDate.placeholder",
              defaultMessage: "Pick a date",
            })}
            radius={"999rem"}
            mb={"xl"}
            minDate={new Date()}
          />
        )}

        <Paper p={"lg"} radius={"24px"} mb={"xl"}>
          <Flex justify={"center"}>
            <Image
              src={FullmaktskollenImage}
              alt="Fullmaktskollen"
              h={38}
              w="auto"
              fit="contain"
            />
          </Flex>
        </Paper>

        <Affix position={{ bottom: 0 }} bg={"white"} w={"100vw"} p={"lg"}>
          <Flex justify={"center"} gap={"md"}>
            <Button onClick={() => prevStep()} variant="outline">
              Tillbaka
            </Button>
            <Button onClick={() => handleNext()} disabled={canProceed}>
              Nästa
            </Button>
          </Flex>
        </Affix>
      </Flex>
    </Flex>
  );
}
